import type {
  ProjectRunFlag,
  ProjectRunFlags,
  WorkRunSpeed,
} from '../../contracts/project-run-flags';

const OPUS_FAST_FLAG: ProjectRunFlag = 'opus_4_8_fast';
const FAST_MODE_FLAG: ProjectRunFlag = 'fast_mode';

export type { WorkRunSpeed };

export const PROJECT_RUN_OPTION_FLAGS = {
  opus48Fast: OPUS_FAST_FLAG,
  fastMode: FAST_MODE_FLAG,
} as const;

export function projectRunFlagsForCreate(
  flags: ProjectRunFlags
): ProjectRunFlags | undefined {
  const enabledEntries = Object.entries(flags).filter(([, enabled]) => enabled);
  if (enabledEntries.length === 0) return undefined;
  return Object.fromEntries(enabledEntries) as ProjectRunFlags;
}

export function workRunSpeedFromFlags(flags: ProjectRunFlags): WorkRunSpeed {
  return flags[FAST_MODE_FLAG] ? 'fast' : 'normal';
}

export function projectRunFlagsWithSpeed(
  flags: ProjectRunFlags,
  speed: WorkRunSpeed
): ProjectRunFlags {
  if (speed === 'fast') {
    return { ...flags, [FAST_MODE_FLAG]: true };
  }
  const next = { ...flags };
  delete next[FAST_MODE_FLAG];
  return next;
}
